import React from "react";
import styles from "../assets/voidIntoProfit.module.css";

const VoidIntoProfit = () => {
  return (
    <div className={styles.page}>
      <div className={styles.container}>
        <div className={styles.content}>
          <div className={styles.titleSection}>
            <h3 className={styles.mainTitle}>
              Maximizing Potential, Minimizing Losses
            </h3>
          </div>

          <div className={styles.description}>
            <p>
              At Global Guardians, we understand the financial strain that
              vacant properties and empty outdoor spaces can place on property
              owners. That's why we offer our innovative Voids into Profit (VIP)
              solutions, designed to transform idle spaces into
              revenue-generating assets. Our VIP services leverage various
              income generation opportunities, including filming, car parking,
              advertising hoardings, events, and exhibitions, to help you unlock
              the full potential of your property portfolio.
            </p>
          </div>

          <div className={styles.whyChooseSection}>
            <h3 className={styles.categoryTitle}>
              Why Choose Global Guardians?
            </h3>

            <div className={styles.featuresRow}>
              <div className={styles.featureCard}>
                <h4 className={styles.featureTitle}>Maximized Returns</h4>
                <p className={styles.featureDescription}>
                  Our VIP solutions are tailored to help you maximize returns on
                  your vacant properties and outdoor spaces, turning them from
                  liabilities into profitable assets.
                </p>
              </div>

              <div className={styles.featureCard}>
                <h4 className={styles.featureTitle}>Diverse Revenue Streams</h4>
                <p className={styles.featureDescription}>
                  We offer a range of income generation options, allowing you to
                  tap into multiple revenue streams and diversify your earnings.
                </p>
              </div>

              <div className={styles.featureCard}>
                <h4 className={styles.featureTitle}>Customized Strategies</h4>
                <p className={styles.featureDescription}>
                  We work closely with each client to develop customized income
                  generation strategies that align with their property
                  portfolio, goals, and target audience.
                </p>
              </div>

              <div className={styles.featureCard}>
                <h4 className={styles.featureTitle}>Professional Management</h4>
                <p className={styles.featureDescription}>
                  Our experienced team handles all aspects of income generation,
                  from securing partnerships and permits to managing logistics
                  and operations, ensuring a hassle-free experience for property
                  owners.
                </p>
              </div>
            </div>
          </div>

          <div className={styles.servicesSection}>
            <div className={styles.titleSection}>
              <h3 className={styles.mainTitle}>Our Solutions</h3>
            </div>

            <div className={styles.serviceCategory}>
              <h3 className={styles.categoryTitle}>
                Filming Location Services
              </h3>

              <div className={styles.servicesRow}>
                <div className={styles.serviceCard}>
                  <h4 className={styles.serviceTitle}>
                    Scouting and Coordination
                  </h4>
                  <p className={styles.serviceDescription}>
                    We facilitate the use of your property as a filming
                    location, handling all aspects of scouting, coordination,
                    and logistics to ensure a smooth and successful production
                    process.
                  </p>
                </div>

                <div className={styles.serviceCard}>
                  <h4 className={styles.serviceTitle}>Licensing and Permits</h4>
                  <p className={styles.serviceDescription}>
                    Our team manages the necessary licensing and permits
                    required for filming activities, ensuring compliance with
                    local regulations and minimizing legal risks.
                  </p>
                </div>

                <div className={styles.serviceCard}>
                  <h4 className={styles.serviceTitle}>Revenue Sharing</h4>
                  <p className={styles.serviceDescription}>
                    We negotiate fair revenue-sharing agreements with production
                    companies, maximizing earnings for property owners while
                    providing competitive pricing for filmmakers.
                  </p>
                </div>
              </div>
            </div>

            <div className={styles.serviceCategory}>
              <h3 className={styles.categoryTitle}>Car Parking Management</h3>

              <div className={styles.servicesRow}>
                <div className={styles.serviceCard}>
                  <h4 className={styles.serviceTitle}>Optimized Utilization</h4>
                  <p className={styles.serviceDescription}>
                    We optimize the use of vacant spaces for car parking,
                    providing convenient and secure parking solutions for
                    drivers while generating revenue for property owners.
                  </p>
                </div>

                <div className={styles.serviceCard}>
                  <h4 className={styles.serviceTitle}>Parking Enforcement</h4>
                  <p className={styles.serviceDescription}>
                    Our team implements parking enforcement measures to ensure
                    compliance with parking regulations and maintain a safe and
                    orderly parking environment.
                  </p>
                </div>

                <div className={styles.serviceCard}>
                  <h4 className={styles.serviceTitle}>
                    Technology Integration
                  </h4>
                  <p className={styles.serviceDescription}>
                    We leverage technology to streamline parking management
                    processes, including online booking systems, payment
                    processing, and license plate recognition.
                  </p>
                </div>
              </div>
            </div>

            <div className={styles.serviceCategory}>
              <h3 className={styles.categoryTitle}>Advertising Hoardings</h3>

              <div className={styles.servicesRow}>
                <div className={styles.serviceCard}>
                  <h4 className={styles.serviceTitle}>Strategic Placement</h4>
                  <p className={styles.serviceDescription}>
                    We identify strategic locations on your property for
                    advertising hoardings, maximizing visibility and exposure to
                    passing traffic and pedestrians.
                  </p>
                </div>

                <div className={styles.serviceCard}>
                  <h4 className={styles.serviceTitle}>
                    Advertising Partnerships
                  </h4>
                  <p className={styles.serviceDescription}>
                    We secure advertising partnerships with brands and agencies,
                    negotiating competitive rates and managing the installation
                    and maintenance of advertising hoardings.
                  </p>
                </div>

                <div className={styles.serviceCard}>
                  <h4 className={styles.serviceTitle}>Creative Design</h4>
                  <p className={styles.serviceDescription}>
                    Our in-house design team creates eye-catching and effective
                    advertising campaigns that resonate with your target
                    audience and enhance the aesthetics of your property.
                  </p>
                </div>
              </div>
            </div>

            <div className={styles.serviceCategory}>
              <h3 className={styles.categoryTitle}>Events and Exhibitions</h3>

              <div className={styles.servicesRow}>
                <div className={styles.serviceCard}>
                  <h4 className={styles.serviceTitle}>Venue Management</h4>
                  <p className={styles.serviceDescription}>
                    We transform vacant spaces into versatile event venues,
                    suitable for a wide range of events and exhibitions,
                    including corporate functions, product launches, and art
                    installations.
                  </p>
                </div>

                <div className={styles.serviceCard}>
                  <h4 className={styles.serviceTitle}>Event Planning</h4>
                  <p className={styles.serviceDescription}>
                    Our experienced event planners handle all aspects of event
                    planning, from logistics and promotion to catering and
                    security, ensuring a seamless and successful event
                    experience.
                  </p>
                </div>

                <div className={styles.serviceCard}>
                  <h4 className={styles.serviceTitle}>Community Engagement</h4>
                  <p className={styles.serviceDescription}>
                    We organize community events and exhibitions to engage local
                    residents and businesses, fostering a sense of community and
                    belonging within the area.
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div className={styles.contactSection}>
            <h4 className={styles.contactTitle}>Get in Touch</h4>
            <p className={styles.contactDescription}>
              Turn your vacant properties and empty outdoor spaces into
              profitable assets with Global Guardians VIP solutions. Contact us
              today to learn more about how we can help you maximize the
              potential of your property portfolio and generate sustainable
              income.
            </p>
            <p className={styles.contactEmail}>
              Contact:{" "}
              <a href="mailto:clientcare@global-guardians.co.uk">
                clientcare@global-guardians.co.uk
              </a>{" "}
              and we will be happy to discuss your requirements.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default VoidIntoProfit;
